// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/codebuild/output/src4207611456/src/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/explore.tsx": { enumerable: true, get() { return require("/codebuild/output/src4207611456/src/app/(tabs)/explore.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("/codebuild/output/src4207611456/src/app/(tabs)/index.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/codebuild/output/src4207611456/src/app/_layout.tsx"); } },
  "./modal.tsx": { enumerable: true, get() { return require("/codebuild/output/src4207611456/src/app/modal.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;